module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAOVBMVEUAAADg4OPg4Obi4uXg4OXg4OTh4eTl5eXk5OTi4ubg4OPf3+Tg4OTg4OTf3+Tg4OXh4eTh4eTf3+NL79zIAAAAEnRSTlMA+VlOeL5fJxNF1drWzXFqZlR4jnRSAAAAjUlEQVQY03WRWw6FIAxEW6jUq/jq/hd7S2WMCXE+eJyUYSjUpUWkKL2VFgstiaB5skfT3NlqL603RR1qw88XdecAsvnQfKvPO2WO7dluI1JzcXbq7BcHlIqBXp1ZITFQMBNAu4gyYD/e/DJoIQVjBtU7kjgL36NF6uG3M0r4QPjhmR8NGVs3NLkmkPE7/vOFD8KIdoUvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/delete.png
// module id = v8EY
// module chunks = 0 58 59 61 62 63